<template>
  <div class="match-bets-container">
    <div class="row sport-header-bets">
      <div
        class="sport-header-bet"
        v-for="(sportBet, index) in matchBetsHeaders.slice(0, 4)"
        :key="sportBet.id">
        <sport-header-bet
          :bet="sportBet"
          :bet-style="{ betIdColored: coloredId, betNamePosition: 'left', betIdWidth: 'large' }"
          :special="matchBets[index].initialSpecial"
        />
      </div>
    </div>
    <div class="row match-bets">
      <transition name="slide-locked">
        <div
          class="match-bets"
          :key="'special-plus-locked-1:1'"
          v-if="matchBettingStatus">
          <match-bet
            v-for="matchBet in matchBets.slice(0, 4)"
            :key="matchBet.id"
            :match-bet="matchBet"
          />
        </div>
        <match-locked
          :match-status-period="matchStatusPeriod"
          :key="'special-plus-locked-1:2'"
          v-else
        />
      </transition>
    </div>
    <div class="row sport-header-bets">
      <div
        class="sport-header-bet"
        v-for="(sportBet, index) in matchBetsHeaders.slice(4, 8)"
        :key="sportBet.id">
        <sport-header-bet
          :bet="sportBet"
          :bet-style="{ betIdColored: coloredId, betNamePosition: 'left', betIdWidth: 'large' }"
          :special="matchBets[4+index].initialSpecial"
        />
      </div>
    </div>
    <div class="row match-bets row-light">
      <transition name="slide-locked">
        <div
          class="match-bets"
          :key="'special-plus-locked-2:1'"
          v-if="matchBettingStatus">
          <match-bet
            v-for="matchBet in matchBets.slice(4, 8)"
            :key="matchBet.id"
            :match-bet="matchBet"
          />
        </div>
        <match-locked
          :match-status-period="matchStatusPeriod"
          :key="'special-plus-locked-2:2'"
          v-else
        />
      </transition>
    </div>
    <div class="row sport-header-bets">
      <div
        class="sport-header-bet"
        v-for="(sportBet, index) in matchBetsHeaders.slice(8, 12)"
        :key="sportBet.id">
        <sport-header-bet
          :bet="sportBet"
          :bet-style="{ betIdColored: coloredId, betNamePosition: 'left', betIdWidth: 'large' }"
          :special="matchBets[8+index].initialSpecial"
        />
      </div>
    </div>
    <div class="row match-bets">
      <transition name="slide-locked">
        <div
          class="match-bets"
          :key="'special-plus-locked-3:1'"
          v-if="matchBettingStatus">
          <match-bet
            v-for="matchBet in matchBets.slice(8, 12)"
            :key="matchBet.id"
            :match-bet="matchBet"
          />
        </div>
        <match-locked
          :match-status-period="matchStatusPeriod"
          :key="'special-plus-locked-3:2'"
          v-else
        />
      </transition>
    </div>
    <div class="row sport-header-bets">
      <div
        class="sport-header-bet"
        v-for="(sportBet, index) in matchBetsHeaders.slice(12, 16)"
        :key="sportBet.id">
        <sport-header-bet
          :bet="sportBet"
          :bet-style="{ betIdColored: coloredId, betNamePosition: 'left', betIdWidth: 'large' }"
          :special="matchBets[12+index].initialSpecial"
        />
      </div>
    </div>
    <div class="row match-bets row-light">
      <transition name="slide-locked">
        <div
          class="match-bets"
          :key="'special-plus-locked-4:1'"
          v-if="matchBettingStatus">
          <match-bet
            v-for="matchBet in matchBets.slice(12, 16)"
            :key="matchBet.id"
            :match-bet="matchBet"
          />
        </div>
        <match-locked
          :match-status-period="matchStatusPeriod"
          :key="'special-plus-locked-4:2'"
          v-else
        />
      </transition>
    </div>
    <div v-if="visualizationDisabled">
      <div
        v-for="i in 5"
        :key="i">
        <div class="row sport-header-bets">
          <div
            class="sport-header-bet"
            v-for="(sportBet, index) in matchBetsHeadersExtended(i)"
            :key="sportBet.id">
            <sport-header-bet
              :bet="sportBet"
              :bet-style="{ betIdColored: coloredId, betNamePosition: 'left', betIdWidth: 'large' }"
              :special="matchBetSpecial(i, index)"
            />
          </div>
        </div>
        <div class="row match-bets row-light">
          <transition name="slide-locked">
            <div
              class="match-bets"
              :key="`special-plus-locked-${4 + i}:1`"
              v-if="matchBettingStatus">
              <match-bet
                v-for="matchBet in matchBetsExtended(i)"
                :key="matchBet.id"
                :match-bet="matchBet"
              />
            </div>
            <match-locked
              :match-status-period="matchStatusPeriod"
              :key="`special-plus-locked-${4 + i}:2`"
              v-else
            />
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SportHeaderBet from '@/components/common/sport-header-bet/SportHeaderBet.vue';
import MatchBet from '@/components/common/match-bet/MatchBet.vue';
import MatchLocked from '@/components/common/match-locked/MatchLocked.vue';

export default {
  name: 'MatchBets',
  components: {
    SportHeaderBet,
    MatchBet,
    MatchLocked,
  },
  props: {
    idMatch: {
      required: true,
      type: Number,
    },
    idSport: {
      required: true,
      type: Number,
    },
    matchBettingStatus: {
      required: true,
      type: Boolean,
    },
    matchStatusPeriod: {
      required: true,
      type: String,
    },
    coloredId: {
      required: true,
      type: Boolean,
    },
    visualizationDisabled: {
      required: true,
      type: Boolean,
    },
  },
  computed: {
    matchBets() {
      const matchBets = this.$store.getters.getActiveMatchBets(this.idMatch, this.betsCount);

      const diff = this.betsCount - matchBets.length;
      if (diff > 0) {
        for (let i = 0; i < diff; i += 1) {
          matchBets.push({});
        }
      }

      return matchBets;
    },
    matchBetsHeaders() {
      const headerBets = [];

      for (let i = 0; i < this.betsCount; i += 1) {
        const matchBet = this.matchBets[i];
        if (matchBet && Object.keys(matchBet).length > 0) {
          headerBets.push(this.$store.state.live.bets[this.idSport][matchBet.idBet]);
        } else {
          headerBets.push({});
        }
      }

      return headerBets;
    },
    betsCount() {
      return this.visualizationDisabled ? 36 : 16;
    },
  },
  methods: {
    matchBetsHeadersExtended(i) {
      const arg = 16 + (4 * (i - 1));
      return this.matchBetsHeaders.slice(arg, arg + 4);
    },
    matchBetsExtended(i) {
      const arg = 16 + (4 * (i - 1));
      return this.matchBets.slice(arg, arg + 4);
    },
    matchBetSpecial(i, index) {
      const arg = 16 + (4 * (i - 1));
      return this.matchBets[arg + index].initialSpecial;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.match-bets-container {
  overflow: hidden;
}

.row {
  color: $color-text-primary;
  background-color: $match-color-back;
  border: 0;

  &.row-light {
    background-color: $match-color-back-even;
  }
}

.sport-header-bets {
  color: $color-text-primary;
  font-weight: $font-weight-bold;
  @if $sport-header-gradient == false {
    background-color: $sport-header-color-back;
  } @else {
    background-image: $sport-header-color-back-gradient;
  }

  .sport-header-bet {
    float: left;
    width: 25%;
  }

  /deep/ .bet-id:after {
    background-color: $sport-header-bet-top-color-back !important;
  }
}

.match-bets {
  .match-bet {
    float: left;
    width: 25%;
  }

  .match-bet:first-child {
    &:after {
      background-color: transparent !important;
    }
  }
}

.locked:after {
  width: 0 !important;
}
</style>
